import { isChangePageUrl, isChangeShortUrl } from '@change-corgi/core/security';

import type { AppRouteBeforeServerRenderContext } from '#src/shared/routes';

/**
 * Skips the offsite interstitial for destinations that are safe to send the user to directly:
 * Change.org pages and Change short links. Anything else, including a missing, malformed or
 * array-valued `to`, falls through to the interstitial page, which handles those cases itself.
 *
 * An `http:` destination is upgraded to `https:` before the check, as links to `http://` Change
 * pages are common in older content.
 */
export function redirectIfAllowed({ query, utilities, redirect }: AppRouteBeforeServerRenderContext): void {
	const { to } = query;
	if (typeof to !== 'string' || !URL.canParse(to)) return;

	const destination = new URL(to);
	if (destination.protocol === 'http:') destination.protocol = 'https:';

	const baseUrl = utilities.resolveUrl('/');
	if (isChangePageUrl(destination.href, { baseUrl }) || isChangeShortUrl(destination.href, { baseUrl })) {
		redirect(destination.href);
	}
}
